import {createTheme} from '@mui/material/styles';
import type {} from '@mui/lab/themeAugmentation';

import themeOptions from './themeOptions';
import {overrides} from './overrides';

export const themeDecisions = createTheme(themeOptions({mode: 'light'}));

themeDecisions.components = overrides(themeDecisions);
